import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType from 'utils/asset/getContentItemType';
import Button from 'components/Button';
import Box from 'components/Box';
import Card from 'components/Card';
import Stack from 'components/Stack';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Meter from 'components/Meter';
import Icon from 'components/Icon';
import { TinyHorizontalCard } from 'components/ContentCards';
import InlineList from 'components/InlineList';
import getPictureUrl from 'utils/image/getPictureUrl';
var UploadProgressModal = function UploadProgressModal(_ref) {
  var isInProgress = _ref.isInProgress,
    isProcessing = _ref.isProcessing,
    uploadProgress = _ref.uploadProgress,
    asset = _ref.asset,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    onEdit = _ref.onEdit;
  var name = asset.name,
    thumbnailId = asset.thumbnailId,
    assetContentType = asset.assetContentType,
    customType = asset.customType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'playlist-editor-dialog-title';
  var modalTitle = isInProgress ? t("content_uploading_".concat(assetContentType)) : t('content_upload_complete');
  var rawType = getContentItemType({
    customType: customType,
    type: assetContentType
  });
  var icon = getContentItemIconFromType(rawType);
  var progress = uploadProgress ? "".concat(t('form_uploaded_progress', {
    progress: "".concat(Math.ceil(uploadProgress), "%")
  })) : undefined;
  var buttonProps = {
    icon: 'edit',
    label: t('actions_click_to_edit'),
    onClick: onEdit
  };
  var meterId = 'upload-progress-meter';
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: !isInProgress ? onClose : function () {
      return undefined;
    }
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: modalTitle,
    titleId: titleId,
    onClose: !isInProgress ? onClose : undefined,
    size: "large"
  }), /*#__PURE__*/React.createElement(Panel, null, isInProgress ? t('content_uploading_file_info') : isProcessing ? /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, t('content_upload_successful'), t('content_processing_file_info')) : t('content_upload_successful_and_ready')), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(TinyHorizontalCard, {
    isImageLeft: true,
    title: name,
    subtitle: /*#__PURE__*/React.createElement(InlineList, {
      as: "span",
      itemAs: "span",
      splitBy: "dot",
      display: "inline"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      dimmed: true,
      name: icon,
      mr: "xxs"
    }), t("file_type_".concat(assetContentType))), isInProgress && t('actions_click_to_edit')),
    imageSource: getPictureUrl({
      id: thumbnailId
    }),
    icon: icon,
    buttonProps: isInProgress ? buttonProps : undefined
  }), /*#__PURE__*/React.createElement(Meter, {
    value: uploadProgress ? uploadProgress / 100 : undefined,
    color: "positive",
    id: meterId
  }), /*#__PURE__*/React.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: meterId
  }, progress)))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, isInProgress ? /*#__PURE__*/React.createElement(Button, {
    variant: "transparent",
    onClick: onCancel
  }, t('actions_cancel_upload')) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: onClose
  }, t('actions_view_in_playlist')))));
};
export default UploadProgressModal;